import React, { useEffect } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";
import _ from "lodash";
import { StackActions } from "@react-navigation/native";
import BackgroundAdmin from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import ButtonLayout from "../components/ButtonLayout";

export default function (props) {
  return (
    <BackgroundAdmin scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View style={{ marginTop: 50 }}></View>
      <Title>Elija instalación</Title>
      {props.route.params.instalaciones.map((e) => (
        <ButtonLayout
          text={e.nombre}
          key={e._id}
          onPress={() =>
            props.navigation.navigate(props.route.params.next, {
              ...props.route.params,
              instalaciones: props.route.params.instalaciones.filter(
                (y) => e._id == y._id
              )[0],
            })
          }>
          {" "}
        </ButtonLayout>
      ))}
    </BackgroundAdmin>
  );
}
